

export const pwdMinRequirements = (password: string): boolean => {
    const MIN_PASSWORD_LENGTH = 8;
    return (password.length >= MIN_PASSWORD_LENGTH &&
    /[A-Z]/.test(password) &&
    /[0-9]/.test(password) &&
    /[!@#$]/.test(password));
}